import React, { useState, useEffect } from 'react';
import { Moon, Sun, Github, Mail, Heart, Languages, ChevronDown, PlusCircle } from 'lucide-react';
import ToolCard from './components/ToolCard';
import ApplicationForm from './components/ApplicationForm';
import { translations, getCategories, detectBrowserLanguage, allLanguages, type Language } from './translations';

interface Tool {
  id: string;
  icon: string;
  name: string;
  description: string;
  url: string;
  category: string;
  isNew?: boolean;
  isHot?: boolean;
  isGrowing?: boolean;
}

const TOOLS: Tool[] = [
  {
    id: '1',
    icon: '🔍',
    name: 'Tool Search',
    description: 'AI驱动的开源工具搜索引擎，不需要背工具名，自然语言搜索即可找到最适合的工具',
    url: 'https://douya.chat',
    category: '效率工具',
    isHot: true
  },
  {
    id: '2',
    icon: '🎬',
    name: 'Movie Search',
    description: '电影推荐工具 - 根据你的喜好、心情、场景智能推荐电影，发现你的下一部最爱',
    url: '#',
    category: '效率工具',
    isNew: true,
    isGrowing: true
  },
  {
    id: '3',
    icon: '🍳',
    name: 'Recipe Search',
    description: '菜谱推荐工具 - 输入食材或口味偏好，AI为你推荐完美菜谱，让每次烹饪都成为享受',
    url: '#',
    category: '生活服务',
    isNew: true,
    isGrowing: true
  },
  {
    id: '4',
    icon: '📚',
    name: 'Book Search',
    description: '书籍推荐工具 - 基于你的阅读历史和兴趣，发现值得阅读的好书，让知识滋养你的心灵',
    url: '#',
    category: '效率工具',
    isNew: true,
    isGrowing: true
  },
  {
    id: '5',
    icon: '💼',
    name: 'Job Search',
    description: '求职岗位分析 - AI分析职位描述，匹配你的技能，发现最佳工作机会，让求职更高效',
    url: '#',
    category: '职业发展',
    isNew: true,
    isGrowing: true
  },
  {
    id: '6',
    icon: '🎓',
    name: 'Course Search',
    description: '在线课程推荐 - 根据你的学习目标，智能推荐优质课程，让成长之路更清晰',
    url: '#',
    category: '教育学习',
    isNew: true,
    isGrowing: true
  },
  {
    id: '7',
    icon: '🎙️',
    name: 'Podcast Market',
    description: '播客集市 - 文本一键转有声内容，快速创建专业播客，让声音传播你的思想',
    url: '#',
    category: '内容创作',
    isNew: true,
    isGrowing: true
  },
  {
    id: '8',
    icon: '📡',
    name: 'Promo Assistant',
    description: '推广助手 - 同频内容全球分发枢纽，精准触达目标受众，让内容价值最大化',
    url: '#',
    category: '营销推广',
    isNew: true,
    isGrowing: true
  },
  {
    id: '9',
    icon: '🔬',
    name: 'Deep Research',
    description: '专业智库深度调研 - AI驱动的深度研究工具，快速获取专业洞察，助力明智决策',
    url: '#',
    category: '研究分析',
    isNew: true,
    isGrowing: true
  },
  {
    id: '10',
    icon: '✨',
    name: 'AI Soul Workshop',
    description: 'AI灵魂工坊 - 自定义人格创造平台，打造独一无二的AI角色，让创意变为现实',
    url: '#',
    category: '创意工具',
    isNew: true,
    isGrowing: true
  },
  {
    id: '11',
    icon: '🤔',
    name: 'Thinker Lite',
    description: '思想者轻社区 - 无焦虑哲思分享空间，深度思考与心灵对话的精神家园',
    url: '#',
    category: '社区',
    isNew: true,
    isGrowing: true
  },
  {
    id: '12',
    icon: '🌿',
    name: 'Open Source Hub',
    description: '开源生态 - 沉浸式文档与开发者枢纽，连接开源世界，让协作更简单',
    url: '#',
    category: '开发工具',
    isNew: true,
    isGrowing: true
  },
  {
    id: '13',
    icon: '💭',
    name: 'AI Soul Chat',
    description: 'AI灵魂对话 - 私密创作工坊，与AI深度对话，激发创意灵感，让思想自由流淌',
    url: '#',
    category: '创意工具',
    isNew: true,
    isGrowing: true
  },
  {
    id: '14',
    icon: '🔬',
    name: 'Research Share',
    description: '研享社 - AI原生专业研究成果共享经济平台，连接研究者，让知识价值最大化',
    url: '#',
    category: '研究分析',
    isNew: true,
    isGrowing: true
  },
  {
    id: '15',
    icon: '🤖',
    name: 'Silicon Workspace',
    description: '硅基协同工作台 - AI输出自动分类归入6大模块，解决碎片化痛点，让协同更高效',
    url: '#',
    category: '效率工具',
    isNew: true,
    isGrowing: true
  },
  {
    id: '16',
    icon: '🔧',
    name: 'Bio Robot DIY',
    description: '儿童科普 DIY 生物机器人 - 展示系列小实验，让小朋友在家轻松探索生命科学奥秘',
    url: '#',
    category: '教育学习',
    isNew: true,
    isGrowing: true
  },
  {
    id: '17',
    icon: '📜',
    name: 'ACP Protocol',
    description: 'ACP开源协议 - Structured AI Collaboration Protocol，定义7种标准化数据结构，解决AI协同数据互通',
    url: '#',
    category: '开发工具',
    isHot: true,
    isGrowing: true
  },
  {
    id: '18',
    icon: '🎯',
    name: 'Prototype Lab',
    description: '原型实验室 - 快速创建产品原型，AI自动生成交互流程，加速产品迭代',
    url: '#',
    category: '设计工具',
    isNew: true,
    isGrowing: true
  },
  {
    id: '19',
    icon: '🌟',
    name: 'Kids Original',
    description: '少儿原创 - 让孩子发挥无限创意，展示原创作品，培养下一代创新者',
    url: '#',
    category: '教育学习',
    isNew: true,
    isGrowing: true
  },
  {
    id: '20',
    icon: '🤝',
    name: 'Silver Care',
    description: '银发互助 - 温暖的老年人互助社区，提供陪伴服务，让晚年生活更美好',
    url: '#',
    category: '社区',
    isNew: true,
    isGrowing: true
  },
  {
    id: '21',
    icon: '🎬',
    name: 'AI Native Video',
    description: 'AI原生视频 - 用AI技术快速生成专业视频内容，让创作更简单高效',
    url: '#',
    category: '内容创作',
    isNew: true,
    isGrowing: true
  }
];

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [language, setLanguage] = useState<Language>('zh');
  const [selectedCategory, setSelectedCategory] = useState('全部');
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const [showApplicationForm, setShowApplicationForm] = useState(false);

  const t = translations[language];
  const CATEGORIES = getCategories(language);

  // 浏览器语言自动检测（仅在首次加载时）
  useEffect(() => {
    const detectedLang = detectBrowserLanguage();
    setLanguage(detectedLang);
    setSelectedCategory(translations[detectedLang].categoryAll);
  }, []);

  // 切换语言
  const selectLanguage = (lang: Language) => {
    setLanguage(lang);
    setSelectedCategory(translations[lang].categoryAll);
    setShowLanguageMenu(false);
  };

  // 点击外部关闭语言菜单
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (showLanguageMenu && !target.closest('.language-menu')) {
        setShowLanguageMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showLanguageMenu]);

  const filteredTools = selectedCategory === t.categoryAll
    ? TOOLS
    : TOOLS.filter((tool, index) => {
        // 根据当前语言的分类进行过滤
        const toolCategory = t.tools[index].category;
        return toolCategory === selectedCategory;
      });

  return (
    <div className={isDarkMode ? 'dark' : ''} dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
        {/* 顶部导航 */}
        <header className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm shadow-sm sticky top-0 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <div className="flex items-center justify-between">
              {/* Logo */}
              <div className="flex items-center gap-3">
                <div className="text-3xl">🌊</div>
                <div>
                  <h1 className="font-bold text-xl text-gray-800 dark:text-gray-100">Douya Center <span className="text-sm font-normal text-gray-500 dark:text-gray-400">（个人兴趣，随性而动，多数空白，用于测试）</span></h1>
                  <p className="text-[10px] text-gray-400 dark:text-gray-500 leading-tight max-w-md">{t.logoSubtitle}</p>
                </div>
              </div>

              {/* 右侧操作 */}
              <div className="flex items-center gap-3">
                {/* 申请入驻按钮（暂时禁用） */}
                <button
                  disabled
                  className="flex items-center gap-1 px-3 py-2 rounded-lg bg-gradient-to-r from-purple-500 to-pink-600 opacity-50 cursor-not-allowed text-sm font-medium text-white transition-all shadow-md"
                  title={language === 'zh' ? '审批系统开发中' : 'Approval system in development'}
                >
                  <PlusCircle className="w-4 h-4" />
                  <span>{language === 'zh' ? '申请入驻' : language === 'en' ? 'Apply Now' : 'Apply'}</span>
                </button>

                {/* 语言切换下拉菜单 */}
                <div className="relative language-menu">
                  <button
                    onClick={() => setShowLanguageMenu(!showLanguageMenu)}
                    className="flex items-center gap-1 px-3 py-2 rounded-lg bg-blue-50 dark:bg-blue-900/30 hover:bg-blue-100 dark:hover:bg-blue-900/50 transition-colors text-sm font-medium text-blue-600 dark:text-blue-400 border border-blue-200 dark:border-blue-800"
                    aria-label="Switch Language"
                  >
                    <Languages className="w-4 h-4" />
                    <span>{t.langName}</span>
                    <ChevronDown className={`w-4 h-4 transition-transform ${showLanguageMenu ? 'rotate-180' : ''}`} />
                  </button>

                  {/* 下拉菜单 */}
                  {showLanguageMenu && (
                    <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-50">
                      <div className="py-1 max-h-96 overflow-y-auto">
                        {allLanguages.map((lang) => (
                          <button
                            key={lang.code}
                            onClick={() => selectLanguage(lang.code)}
                            className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors ${
                              language === lang.code
                                ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 font-medium'
                                : 'text-gray-700 dark:text-gray-300'
                            }`}
                          >
                            <span className="mr-2">{lang.nativeName}</span>
                            <span className="text-gray-400 text-xs">({lang.name})</span>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* 主题切换 */}
                <button
                  onClick={() => setIsDarkMode(!isDarkMode)}
                  className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                  aria-label="切换主题"
                >
                  {isDarkMode ? (
                    <Sun className="w-5 h-5 text-gray-600 dark:text-gray-300" />
                  ) : (
                    <Moon className="w-5 h-5 text-gray-600" />
                  )}
                </button>
              </div>
            </div>
          </div>
        </header>

        {/* 主内容区 */}
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {/* Hero 区域 */}
          <div className="text-center mb-12">
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-800 dark:text-gray-100 mb-4">
              {t.heroTitle}
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-400 mb-8">
              {t.heroSubtitle}
            </p>

            {/* 分类筛选 */}
            <div className="flex flex-wrap justify-center gap-1.5 mb-8 max-w-5xl mx-auto">
              {CATEGORIES.map(category => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-3 py-1.5 rounded-lg font-medium transition-all text-sm ${
                    selectedCategory === category
                      ? 'bg-[#165DFF] text-white shadow-lg'
                      : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          {/* 工具网格 */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredTools.map((tool, index) => {
              const toolData = t.tools[index];
              return (
                <ToolCard
                  key={tool.id}
                  icon={tool.icon}
                  name={toolData.name}
                  description={toolData.description}
                  url={tool.url}
                  category={toolData.category}
                  isNew={tool.isNew}
                  isHot={tool.isHot}
                  isGrowing={tool.isGrowing}
                  growingText={t.growing}
                  comingSoonText={t.comingSoon}
                />
              );
            })}
          </div>

          {/* 统计信息 */}
          <div className="mt-16 text-center">
            <div className="inline-flex items-center gap-8 bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm">
              <div>
                <div className="text-3xl font-bold text-[#165DFF]">21</div>
                <div className="text-sm text-gray-600 dark:text-gray-400">{t.statsTools}</div>
              </div>
              <div className="w-px h-12 bg-gray-200 dark:bg-gray-700"></div>
              <div>
                <div className="text-3xl font-bold text-green-600">100%</div>
                <div className="text-sm text-gray-600 dark:text-gray-400">{t.statsAI}</div>
              </div>
              <div className="w-px h-12 bg-gray-200 dark:bg-gray-700"></div>
              <div>
                <div className="text-3xl font-bold text-orange-600">7x24</div>
                <div className="text-sm text-gray-600 dark:text-gray-400">{t.statsOnline}</div>
              </div>
            </div>
          </div>
        </main>

        {/* 页脚 */}
        <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 mt-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="text-center text-sm text-gray-600 dark:text-gray-400 space-y-2">
              <p className="flex items-center justify-center gap-2">
                Made with <Heart className="w-4 h-4 text-red-500" /> by {t.footerMadeWith}
              </p>
              <p>{t.footerCopyright}</p>
              <div className="flex justify-center gap-6">
                <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#165DFF] transition-colors flex items-center gap-1">
                  <Github className="w-4 h-4" />
                  {t.footerGithub}
                </a>
                <a href="mailto:douyaworld2026@163.com" className="hover:text-[#165DFF] transition-colors flex items-center gap-1">
                  <Mail className="w-4 h-4" />
                  {t.footerFeedback}
                </a>
              </div>
            </div>
          </div>
        </footer>

        {/* 申请表单 */}
        <ApplicationForm
          isOpen={showApplicationForm}
          onClose={() => setShowApplicationForm(false)}
          language={language}
        />
      </div>
    </div>
  );
}

export default App;
